import { OrderFeedbackCollectionState } from './types'

// `allowWrittenFeedbackCollection` starts TRUE, unlike the CMS post-order-email
// slice it is modelled on. The merchant column it mirrors
// (`allow_written_feedback_collection`) defaults to true in nexus, so written
// feedback is collected unless a merchant deliberately turns it off. Seeding
// false here would flash the off-state amber note on every first paint, before
// the initialize hook resolves the merchant.
export const initialOrderFeedbackCollectionState: OrderFeedbackCollectionState =
  {
    allowWrittenFeedbackCollection: true,
    // Seeded to the same value, so the pane is clean on first paint and Publish
    // starts disabled rather than flashing enabled before the merchant resolves.
    persistedAllowWrittenFeedbackCollection: true,
    isFormSubmitting: false,
  }
